module.exports = __webpack_public_path__ + "img/mapBG.3bfba841.jpg";